import React, {Component} from 'react';
import {connect} from 'react-redux';
import {keyBy, has} from 'lodash';
import {Table} from 'semantic-ui-react';
import {Actions} from '../../../../../common/actions';
import {getTotalColumn, validateUnique} from '../../../../utils';
import Loader from '../../../../../common/components/loader';
import FormSubContract from './form';
import DisplayData from './data';

const initialState = {
  'id': 'AC',
  'numInvoice': '',
  'observation': '',
  'totalDealer': 0.0,
  'total': 0.0,
  'totalTde': 0.0,
  'totalProvider': 0.0,
};

class Subcontract extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
    };
  }

  componentDidMount() {
    this.props.getWarrantyAdminSubcontractList();
  }

  componentDidUpdate() {
    const {subcontracts, handleChangeForm} = this.props;
    if (subcontracts.some((sub) => !has(sub, 'totalDealer'))) {
      const updateSubcontracts = subcontracts.map((sub) => {
        if (!has(sub, 'totalDealer')) {
          sub.totalDealer = 0.0;
        }
        return sub;
      });
      handleChangeForm('subcontracts', updateSubcontracts);
    }
  }

  handleUpdateAmount = (field, value, selectItem) => {
    const {subcontracts, handleChangeForm} = this.props;
    const newSubContracts = subcontracts.map((item) => {
      if (item.id === selectItem.id) {
        return {
          ...selectItem,
          [field]: +value,
        };
      }
      return item;
    });
    handleChangeForm('subcontracts', newSubContracts);
  }
  
  handleUpdateObs = (field, value, selectItem) => {
    const {subcontracts, handleChangeForm} = this.props;
    const newSubContracts = subcontracts.map((item) => {
      if (item.id === selectItem.id) {
        return {
          ...selectItem,
          [field]: value,
        };
      }
      return item;
    });
    handleChangeForm('subcontracts', newSubContracts);
  }

  handleChange = (field, value) => {
    this.setState({
      [field]: value,
    });
  }

 handleAddItem = () => {
   const {handleChangeForm} = this.props;
   const {id, numInvoice, observation, total, totalDealer,
     totalTde, totalProvider} = this.state;
   const newSunContracts = [...this.props.subcontracts];
   const item = {
     id,
     numInvoice,
     observation,
     'totalDealer': +totalDealer,
     'totalTde': +totalTde,
     'totalProvider': +totalProvider,
     'total': +total,
   };

   if (validateUnique(newSunContracts, 'id', id)) {
     newSunContracts.push(item);
     this.setState({
       ...initialState,
     }, () => {
       handleChangeForm('subcontracts', newSunContracts);
     });
   } else {
     this.props.addMessageBoxError(`El item ${id} ya se encuentra en la lista`);
   }
 }

  handleRemoveItem = (id) => {
    const {handleChangeForm} = this.props;
    const subcontracts = [...this.props.subcontracts].filter((item, idx) => idx !== id);
    handleChangeForm('subcontracts', subcontracts);
  }

  render() {
    const {loading, subcontracts, subcontractObject, disabledBtns, subcontractOptions} = this.props;
    
    if (loading) {
      return <div className='twc-loader-subcontracts' >
        <Loader/>
      </div>;
    }

    return (
      <div>
        <div className="warranty-container-table">
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Código</Table.HeaderCell>
                <Table.HeaderCell>Descripción</Table.HeaderCell>
                <Table.HeaderCell>No. de factura</Table.HeaderCell>
                <Table.HeaderCell>Descripción Usuario</Table.HeaderCell>
                <Table.HeaderCell>Monto reclamado por dealer</Table.HeaderCell>
                <Table.HeaderCell>Monto autorizado por TDE</Table.HeaderCell>
                <Table.HeaderCell>Monto reclamado a fabrica</Table.HeaderCell>
                <Table.HeaderCell>Valor</Table.HeaderCell>
                <Table.HeaderCell/>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {!disabledBtns && <FormSubContract
                subcontractObject={subcontractObject}
                subcontractOptions={subcontractOptions}
                handleChange={this.handleChange}
                {...this.state}
                handleAddItem={this.handleAddItem}
                loading={loading}
              />
              }
              {subcontracts.map((subcontract, idx) => (
                <DisplayData
                  disabledBtns={disabledBtns}
                  key={idx}
                  item={subcontract}
                  idx={idx}
                  handleUpdateAmount= {this.handleUpdateAmount}
                  handleUpdateObs={this.handleUpdateObs}
                  handleRemoveItem={this.handleRemoveItem}
                  subcontractObject={subcontractObject}/>
              ))}
              <Table.Row className="warranty-table-footer">
                <Table.Cell/>
                <Table.Cell/>
                <Table.Cell/>
                <Table.Cell>SUBTOTAL</Table.Cell>
                <Table.Cell>{'$'}{getTotalColumn(subcontracts, 'totalDealer')}</Table.Cell>
                <Table.Cell>{'$'}{getTotalColumn(subcontracts, 'totalTde')}</Table.Cell>
                <Table.Cell>{'$'}{getTotalColumn(subcontracts, 'totalProvider')}</Table.Cell>
                <Table.Cell>{'$'}{getTotalColumn(subcontracts, 'total')}</Table.Cell>
                <Table.Cell/>
              </Table.Row>
            </Table.Body>

          </Table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const subcontractOptions = state.warrantiesAdminCategories.subcontractList.map((item) => ({
    'text': item.type,
    'value': item.type,
    'key': item.type,
  }));

  return {
    'permissions': state.session.permissions,
    'loading': state.warrantiesAdminCategories.loading,
    subcontractOptions,
    'subcontractObject': keyBy(state.warrantiesAdminCategories.subcontractList, 'type'),
  };
};

const {getWarrantyAdminSubcontractList, addMessageBoxError} = Actions;
const mapDispatchToProps = {
  getWarrantyAdminSubcontractList,
  addMessageBoxError,
};

export default connect(mapStateToProps, mapDispatchToProps)(Subcontract);
